import { Sparkles, PanelRightOpen } from 'lucide-react';
import { useAIAgent } from '../context/AIAgentContext';

export function AISidebarToggle() {
  const { isOpen, setIsOpen, messages } = useAIAgent();

  if (isOpen) return null;

  const hasActiveConversation = messages.length > 0;

  return (
    <button
      data-tour="ai-button"
      onClick={() => setIsOpen(true)}
      className="fixed bottom-6 right-6 w-14 h-14
               bg-gradient-primary
               rounded-full shadow-lg hover:shadow-xl
               transition-all duration-200 hover:scale-105
               flex items-center justify-center z-40
               group"
      title={hasActiveConversation ? "Chat fortsetzen" : "KI-Assistent öffnen"}
    >
      {hasActiveConversation ? (
        <PanelRightOpen className="w-6 h-6 text-white" />
      ) : (
        <Sparkles className="w-6 h-6 text-white group-hover:animate-pulse" />
      )}

      {/* Badge for active conversation */}
      {hasActiveConversation && (
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-emerald-500 rounded-full border-2 border-white" />
      )}

      {/* Pulse animation ring - only when no active conversation */}
      {!hasActiveConversation && (
        <span className="absolute inset-0 rounded-full bg-primary-ping animate-ping-primary" />
      )}
    </button>
  );
}
